import { css } from '@linaria/core';

export const textareaClassname = css`
  font-size: 14px;
  padding: 15px;
  padding-bottom: 14px;
  border: 1px solid black;
  border-radius: 0;
  width: 100%;
  resize: vertical;
  &:focus {
    background-color: #F8F8F8;
    border: 1px solid #006CFF;
    outline: none;
    caret-color: #006CFF;
  }
`;

export const textareaWithError = css`
  border: 1px solid #E12147;
`;

export const textareaWithAction = css`
  padding-right: 64px; /* 48 + 16 */
`;

export const actionWrapper = css`
  position: relative;
`;

export const actionContainer = css`
  position: absolute;
  right: 1px;
  top: 1px;
  width: 46px;
  height: 46px;
  display: flex;
`;

export const iconContainer = css`
  pointer-events: none;
  position: absolute;
  right: 15px;
  top: 15px;
`;

export const errorClassname = css`
  padding: 0;
  margin: 0;
  margin-top: 7px;
  font-size: 10px;
  line-height: 10px;
  letter-spacing: 0.3px;
  color: #E12147;
`;

export const countContainer = css`
  display: flex;
  justify-content: flex-end;
`;

export const countClassname = css`
  font-family: 'Open Sans', sans-serif;
  margin: 0;
`;
